import {makeStyles} from "@material-ui/styles";

export default makeStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    },
    marginBottom: {
        marginBottom: theme.spacing(2)
    },
    marginTop: {
        marginTop: theme.spacing(2)
    },
    marginRight: {
        marginRight: theme.spacing(2)
    },
    tableCell: {
        padding: theme.spacing()
    },
    tableCellBorderRight: {
        borderRight: `1px solid ${theme.palette.divider}`
    },
    tableCellBorderLeft: {
        borderLeft: `1px solid ${theme.palette.divider}`
    },
    variantRow: {
        position: "sticky",
        top: 127,
        zIndex: theme.zIndex.appBar - 1,
        background: theme.palette.background.paper,
        height: 65,
        "&> th, &> td": {
            fontWeight: "bold",
            textAlign: "center",
            fontSize: '1rem',
            color: theme.palette.primary.main,
            "&:first-child, &:nth-child(2)": {
                cursor: "pointer"
            }
        }
    },
    variantRow2: {
        position: "sticky",
        top: 191,
        zIndex: theme.zIndex.appBar - 1,
        background: theme.palette.background.paper,
        "&> th": {
            textAlign: "center"
        }
    },
    demandsRow: {
        "&:hover": {
            "& > td": {
                background: theme.palette.background.default
            }
        },
        "&.complete": {
            background: theme.palette.common.lightGreen
        }, "&.incomplete": {
            background: theme.palette.common.lightRed
        }
    },
    demandsCell: {
        padding: theme.spacing(3),
        background: theme.palette.background.greyBackground
    },
    demandsTable: {
        background: theme.palette.background.paper
    },
    buttonColumn: theme.components.table.buttonColumn,
    addCell: {
        textAlign: "right"
    },
    sectionErrorIcon: {
        color: theme.palette.common.error,
    },
    tableMainHeaderRow: {
        "&> th": {
            textAlign: "center",
            verticalAlign: "bottom",
            "&> div": {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }
        }
    },
    noOptions: {
        fontWeight: "bold",
    },
    exceptionChip: {
        "& .MuiChip-label": {
            maxWidth: 800
        }
    },
    moveEntryRadio: {
        width: "100%",
        "&>.MuiFormLabel-root": {
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightBold,
            marginBottom: theme.spacing()
        },
        "& .MuiFormGroup-root .MuiFormControlLabel-root": {
            margin: theme.spacing(0, 0, 1, 0),

            "&:hover": {
                backgroundColor: theme.palette.primary.main
            }
        }
    },
    exceptionName: {
        textAlign: "left !important"
    }

}))